import * as React from "react";
const VideoBlack = (props) => (
  <svg
    width={15}
    height={13}
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.31619 12.5H4.20558C1.80152 12.5 0.948242 10.8138 0.948242 9.24266V3.75734C0.948242 1.41422 1.86246 0.5 4.20558 0.5H8.31619C10.6593 0.5 11.5735 1.41422 11.5735 3.75734V9.24266C11.5735 11.5858 10.6593 12.5 8.31619 12.5ZM4.20558 1.52935C2.43808 1.52935 1.97759 1.98984 1.97759 3.75734V9.24266C1.97759 10.0756 2.26878 11.4707 4.20558 11.4707H8.31619C10.0837 11.4707 10.5442 11.0102 10.5442 9.24266V3.75734C10.5442 1.98984 10.0837 1.52935 8.31619 1.52935H4.20558Z"
      fill="#4B5155"
    />
    <path
      d="M13.6659 10.6373C13.3747 10.6373 13.0022 10.5425 12.5756 10.2446L10.7675 8.9782C10.632 8.88339 10.5508 8.72763 10.5508 8.55833V4.44095C10.5508 4.27165 10.632 4.11589 10.7675 4.02109L12.5756 2.75472C13.3815 2.19264 13.9706 2.35517 14.2483 2.49738C14.5259 2.64637 15 3.03237 15 4.01431V8.9782C15 9.96014 14.5259 10.3529 14.2483 10.4951C14.1196 10.5696 13.9165 10.6373 13.6659 10.6373ZM11.5734 8.28745L13.1648 9.39806C13.4695 9.60799 13.6862 9.62831 13.7743 9.58091C13.8691 9.5335 13.9706 9.34389 13.9706 8.9782V4.02109C13.9706 3.64863 13.8623 3.46578 13.7743 3.41838C13.6862 3.37097 13.4695 3.39129 13.1648 3.60122L11.5734 4.71183V8.28745Z"
      fill="#4B5155"
    />
    <path
      d="M7.3821 6.33061C6.54237 6.33061 5.8584 5.64663 5.8584 4.80691C5.8584 3.96718 6.54237 3.2832 7.3821 3.2832C8.22183 3.2832 8.9058 3.96718 8.9058 4.80691C8.9058 5.64663 8.22183 6.33061 7.3821 6.33061ZM7.3821 4.299C7.10445 4.299 6.8742 4.52925 6.8742 4.80691C6.8742 5.08456 7.10445 5.31481 7.3821 5.31481C7.65975 5.31481 7.89 5.08456 7.89 4.80691C7.89 4.52925 7.65975 4.299 7.3821 4.299Z"
      fill="#4B5155"
    />
  </svg>
);
export default VideoBlack;
